// covered-by: frontends/carrie/src/ask-v2/review/__tests__/rememberedSentence.test.ts

/** Everything from the remediation marker on: she rejected the CLAIM, not the fix. */
const FIX_ONWARDS = /\*\*\s*fix\s*:?\s*\*\*:?[\s\S]*/i;
const FINDING_LABELS =
  /\*\*\s*(issue|fix|reason|artwork shows)\s*:?\s*\*\*:?/gi;
const MAX_REMEMBERED = 240;

/**
 * The defect a finding asserts, without markers, remediation or newlines.
 *
 * why: mirrors `claim_of` in services/warhol/contracts/judgments.py. The two
 * must agree, because this renders the sentence she approves and that one
 * stores the sentence Puntt keeps -- the first live rejection on the epic
 * stored the whole markdown body, `**Issue:** ... **Fix:** ...`, which is
 * unreadable in the Knowledge Database and at the moment she is asked to
 * confirm it.
 */
export function claimOf(findingText: string): string {
  const cleaned = findingText
    .replace(FIX_ONWARDS, "")
    .replace(FINDING_LABELS, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\.+$/, "");
  if (cleaned.length <= MAX_REMEMBERED) return cleaned;
  return `${cleaned
    .slice(0, MAX_REMEMBERED)
    .replace(/\s\S*$/, "")
    .replace(/[,;:]$/, "")}...`;
}
